/* eslint-disable prettier/prettier */
/* eslint-disable */

import connectReducers from '../utils/connectReducers';

import { GET_FEEDBACK_LINK } from '../actions';

import { FAILURE, REQUEST, SUCCESS } from '../actions/utils';

import { IFeedbackLink } from '../api/types';

import genericReducers from './genericReducer';

import { IReducers } from '.';

export type FeedbackLinkState = IFeedbackLink;

const initialState = {} as IFeedbackLink;
const generic = genericReducers<FeedbackLinkState>();
const feedbackLink: IReducers<FeedbackLinkState> = {
  [GET_FEEDBACK_LINK[REQUEST]]: generic.get.request,
  [GET_FEEDBACK_LINK[SUCCESS]]: generic.get.success,
  [GET_FEEDBACK_LINK[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, feedbackLink);
